
import { 
    REVISE_COVERAGE,
    REVISE_COVERAGE_SUCCESS,
    REVISE_COVERAGE_FAIL, 
    REVISE_COVERAGE_RESET,
} from "../actions/reviseCoverageAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const reviseCoverageReducer = (state = initialState, action) => {
    switch (action.type) {
        case REVISE_COVERAGE:
            return {
                ...state,
                apiState: "loading",
            };
        case REVISE_COVERAGE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case REVISE_COVERAGE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case REVISE_COVERAGE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default reviseCoverageReducer;
